var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [_vm._v("Rename this model")]),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.updateModelname($event)
          }
        }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "modelId" },
          domProps: { value: _vm.modelId }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "sw--margin-bottom-4 sw--width-full" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newModelName,
                expression: "newModelName"
              }
            ],
            ref: "modelNameInput",
            staticClass: "sw--width-full",
            attrs: { type: "text", name: "title", placeholder: _vm.modelName },
            domProps: { value: _vm.newModelName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newModelName = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sw-grid-flex sw-grid-flex--align-center" }, [
          _c("div", { staticClass: "sw--margin-left-auto" }, [
            _c(
              "a",
              {
                attrs: {
                  "event-category": "MMC",
                  "event-action": "Tools Rename",
                  "event-label": "Cancel"
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "sw-dms--color-black sw--text-decoration-underline sw--uppercase sw--font-size-14",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.closeNoty($event)
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sw--margin-left-4" }, [
      _c(
        "button",
        {
          staticClass: "sw-dms-button sw-dms-button--red",
          attrs: {
            "event-category": "MMC",
            "event-action": "Tools Rename",
            "event-label": "Ok"
          }
        },
        [
          _c("span", { staticClass: "sw--padding-hor-2 sw--font-size-16" }, [
            _vm._v("OK")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }